import axios from 'axios'

function addTokenInterceptor(axiosInstance) {
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = localStorage?.getItem('ACCESS') || null
            config.headers.Authorization = `Bearer ${token}`
            return config
        },
        (error) => {
            return Promise.reject(error)
        }
    )
    
    axiosInstance.interceptors.response.use(
        (response) => {
            // Return only the data from the response
            return response.data
        },
        (error) => {
            // Handle any errors
            return Promise.reject(error)
        }
    )
}

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_KEY
})

// second API
const instance2 = axios.create({
    baseURL: process.env.REACT_APP_API_KEY2
})
//
addTokenInterceptor(instance)
addTokenInterceptor(instance2)

export { instance, instance2 }
//export default instance